import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'; // Přidat ikony
import en from 'vuetify/lib/locale/en';
import cs from 'vuetify/lib/locale/cs';

Vue.use(Vuetify);

// Sdilene "rodinove" barvy pro next/ popupy (Oak/Jenny/Mewtwo/...) a dalsi
// misto-specificke akcenty, co dnes zijou jako natvrdo zapsany hex/rgba
// primo v komponentach - zapsane tu, aby na ne slo postupne prevest existujici
// mista (viz architecture/frontend.md sekce "Theming"). Stejne pro light i
// dark - jde o brand/tema identitu popupu, ne o kontrast zavisly na tematu.
const sharedThemeTokens = {
    themeOak: '#FFB300',
    themeJenny: '#1E88E5',
    themeMewtwo: '#7B1FA2',
    // "Vitezna zlata" - stadium/trener win obrazovky. Zamerne MIMO herni
    // semantiku (typy pokemonu/HP bar/skilly) popsanou tamtez - tohle je čistě
    // dekorativni "vyhra" motiv, ne informace nesouci vyznam pro hrani.
    victoryGold: '#FFD700',
};

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#6AE754',
                secondary: '#21A87A',
                accent: '#7BA6EA',
                error: '#EF5167',
                warning: '#F3B85D',
                ...sharedThemeTokens,
            },
            dark: {
                primary: '#6AE754',
                secondary: '#21A87A',
                accent: '#7BA6EA',
                error: '#EF5167',
                warning: '#F3B85D',
                ...sharedThemeTokens,
            },
        },
    },
    icons: {
        iconfont: 'mdi', // Použít Material Design Icons
    },
    lang: {
        // 'hyb' pouziva stejne (anglicke) retezce jako 'en' - odpovida
        // dnesnimu vychozimu chovani appky beze zmeny. Viz
        // docs/superpowers/specs/2026-08-24-i18n-cz-en-hyb-design.md sekce F.
        locales: {hyb: en, cs, en},
        current: 'hyb',
    },
});